import { Component } from 'react';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import DateTimeInput from '../inputs/DateTimeInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DateTimeField extends Component {
  render() {
    const {
      autoFocus,
      collapsed,
      disabled,
      formData,
      idSchema,
      isAdditionalProperty,
      onChange,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(DateTimeInput, {
        autoFocus: autoFocus,
        id: idSchema && idSchema.$id,
        disabled: disabled,
        onChange: onChange,
        readOnly: readOnly,
        value: formData || ''
      })
    });
  }
}